
    import '/mnt/src/components/Checkbox/index.md?watch=parent';
    export const demoIndex = {
  ids: ["checkbox-demo-basicdemo","checkbox-demo-group-controlled"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Checkbox/index.md?type=demo')
};